export default __webpack_public_path__ + "static/media/Robot.7b6be62a.png";